module.exports = __webpack_public_path__ + "static/media/Reshenie_SD_Formoplast_OSA_16.02.2018.4026d05f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Reshenie_SD_Formoplast_OSA_16.02.2018.pdf
// module id = 146
// module chunks = 0